import { trackifyPageChange } from "@allianz/tracking";
import { Button, Section } from "@arp/react-ndbx";
import { Typography } from "@mui/material";
import React, { useEffect } from "react";
import Page from "../../../components/Page";
import PageLoadingBackdrop from "../../../components/organisms/PageLoadingBackdrop";
import { RetrieveOnlineButtonStack } from "../../../components/organisms/RetrieveOnlineButtonStack";
import { Application } from "../../../config/const/enums";
import {
  alreadyDeclinedDisclaimer,
  retrieveCommonDisclaimer,
} from "../../../config/disclaimers/disclaimers";
import { useGetQuote } from "../../../hooks/dataHooks/useGetQuoteData";
import useNewBusiness from "../../../hooks/useNewBusiness";
import usePreQualification from "../../../hooks/usePreQualification";
import usePreQualificationPages from "../../../hooks/usePreQualificationPages";
import { matchPPStrings } from "../../../utilities/preQualificationUtils";
import { backToQuotePoint } from "../../../utilities/utils";

function AlreadyDeclinedApplication() {
  const { state } = usePreQualificationPages();
  const { currentPage } = { ...state };
  const { dataSet } = usePreQualification();
  const { personOne, application } = { ...dataSet };
  const { data: quoteData } = useGetQuote();
  const { data: newBusinessState } = useNewBusiness();

  useEffect(() => {
    trackifyPageChange(currentPage?.identifier?.toLowerCase());
  }, []);

  return (
    <Page title={currentPage.title} identifier={currentPage.identifier}>
      <PageLoadingBackdrop />
      <Section md={7} mb={4} mt={{ xs: 10, md: 15 }}>
        <Section mb={3}>
          <Typography variant="h2">
            {retrieveCommonDisclaimer.SORRY_DISCLAIMER}
          </Typography>
        </Section>
        <Section sx={{ mt: 5, mb: { xs: 3, sm: 4 } }}>
          <Section sx={{ maxWidth: { xs: 334 }, mb: 0 }}>
            <img
              width="100%"
              src="https://www.allianzretireplus.com.au/content/dam/onemarketing/azau/allianz-life-dam/images/woman_laptop_headset.svg"
            ></img>
          </Section>
        </Section>
        <Section mb={3} sx={{ textAlign: "left" }}>
          <Typography variant="h5">
            Unfortunately {personOne?.firstName}, your application has already
            been assessed.
          </Typography>
        </Section>
        <Section mb={3} sx={{ textAlign: "left" }}>
          <Typography variant="p3">
            {alreadyDeclinedDisclaimer.ALREADY_ASSESSED}
          </Typography>
        </Section>

        <Section mb={0} mt={0} sx={{ textAlign: "left" }}>
          <Typography variant="p3">• occupation</Typography>
        </Section>
        <Section mb={0} mt={0} sx={{ textAlign: "left" }}>
          <Typography variant="p3">• state of health</Typography>
        </Section>
        <Section mb={0} mt={0} sx={{ textAlign: "left" }}>
          <Typography variant="p3">• family history, or</Typography>
        </Section>
        <Section mb={0} mt={0} sx={{ textAlign: "left" }}>
          <Typography variant="p3">• pastimes</Typography>
        </Section>

        <Section mt={3} mb={3} sx={{ textAlign: "left" }}>
          <Typography variant="p3">
            {alreadyDeclinedDisclaimer.ALREADY_DECLINED_CALLBACK}
          </Typography>
        </Section>
      </Section>
      {state.application === Application.CONTACT_CENTER ? (
        <Section mt={9} md={4} mb={12}>
          <Button
            id="cc-processing-continue"
            ariaLabel="continue"
            variant="contained"
            color="primary"
            size="medium"
            onClick={() => backToQuotePoint(Application.CONTACT_CENTER)}
            type="button"
          >
            {retrieveCommonDisclaimer.CLOSE}
          </Button>
        </Section>
      ) : (
        <Section md={10} mt={9} mb={12}>
          <RetrieveOnlineButtonStack
            backToQuotePoint={backToQuotePoint}
            showCallButton={
              matchPPStrings(newBusinessState.auraStatus) ? false : true
            }
          />
        </Section>
      )}
    </Page>
  );
}

export default AlreadyDeclinedApplication;
